

import { useEffect, useState } from "react";
import styles from "./EventGallery.module.css";

// const API_URL =
//   import.meta.env.VITE_API_URL || "http://127.0.0.1:8000/api";
const API_URL = "https://atlastravelhouse.com";


const EventGallery = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        setError("");

        const response = await fetch(`${API_URL}/api/event-gallery/`);

        if (!response.ok) {
          throw new Error("Failed to fetch event gallery.");
        }

        const data = await response.json();

        setEvents(Array.isArray(data) ? data : data.results || []);
      } catch (err) {
        setError(err.message || "Something went wrong.");
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const formatDate = (date) => {
    if (!date) return "";

    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  /*
   * If API has finished loading and there are no events,
   * don't render the section at all.
   */
  if (!loading && events.length === 0) {
    return null;
  }

  if (loading) {
    return (
      <section className={styles.eventGallerySection}>
        <div className={styles.eventGalleryContainer}>

          <div className={styles.sectionHeader}>
            <span className={styles.sectionEyebrow}>
              EVENT GALLERY
            </span>

            <h1 className={styles.sectionTitle}>
              Moments that <span>stay.</span>
            </h1>

            <p className={styles.sectionDescription}>
              Explore photographs and videos from events curated and
              managed by EventByAtlas.
            </p>
          </div>

          <div className={styles.eventGrid}>
            {[1, 2, 3].map((item) => (
              <div
                key={item}
                className={`${styles.eventCard} ${styles.skeletonCard}`}
              >
                <div className={styles.skeletonTop}>
                  <div className={styles.skeletonLogo} />
                  <div className={styles.skeletonTag} />
                </div>

                <div className={styles.skeletonSmall} />
                <div className={styles.skeletonTitle} />
                <div className={styles.skeletonMeta} />
                <div className={styles.skeletonMetaSmall} />

                <div className={styles.skeletonLinks}>
                  <div />
                  <div />
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className={styles.eventGallerySection}>
        <div className={styles.eventGalleryContainer}>
          <div className={styles.galleryState}>
            <span className={styles.stateIcon}>!</span>

            <h3>Unable to load events</h3>

            <p>
              We couldn't load the event gallery right now.
              Please try again later.
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={styles.eventGallerySection}>
      <div className={styles.eventGalleryContainer}>

        {/* Section Header */}
        <div className={styles.sectionHeader}>
          

          <h1 className={styles.sectionTitle}>
            Moments that <span>stay.</span>
          </h1>

          <p className={styles.sectionDescription}>
            Explore your memories from events curated and
            managed by Us.
          </p>
        </div>

        {/* Event Grid */}
        <div className={styles.eventGrid}>
          {events.map((event) => {

            const links = [...(event.links || [])].sort(
              (a, b) =>
                (a.display_order || 0) -
                (b.display_order || 0)
            );

            return (
              <article
                key={event.id}
                className={styles.eventCard}
              >

                {/* Card Header */}
                <div className={styles.cardHeader}>

                  <div className={styles.clientLogo}>
                    {event.client_logo ? (
                      <img
                        src={event.client_logo}
                        alt={`${event.client_name} logo`}
                      />
                    ) : (
                      <span>
                        {event.client_name
                          ?.charAt(0)
                          ?.toUpperCase() || "A"}
                      </span>
                    )}
                  </div>

                  <span className={styles.eventTag}>
                    EVENT
                  </span>

                </div>

                {/* Event Information */}
                <div className={styles.eventContent}>

                  <span className={styles.clientName}>
                    {event.client_name}
                  </span>

                  <h2 className={styles.eventName}>
                    {event.event_name}
                  </h2>

                  <div className={styles.eventMeta}>

                    <div className={styles.metaItem}>
                      <span className={styles.metaIcon}>
                        ◷
                      </span>

                      <span>
                        {formatDate(event.event_date)}
                      </span>
                    </div>

                    <div className={styles.metaItem}>
                      <span className={styles.metaIcon}>
                        ⌖
                      </span>

                      <span>
                        {event.venue}
                      </span>
                    </div>

                  </div>

                </div>

                {/* Google Drive Links */}
                {links.length > 0 && (
                  <div className={styles.eventLinksWrapper}>

                    <p className={styles.downloadText}>
                      Download your memories from here:
                    </p>

                    <div className={styles.eventLinks}>

                      {links.map((link) => (
                        <a
                          key={link.id}
                          href={link.drive_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.driveButton}
                        >
                          <span className={styles.driveButtonText}>
                            {link.label || "View Files"}
                          </span>

                          <span className={styles.driveArrow}>
                            ↗
                          </span>
                        </a>
                      ))}

                    </div>

                  </div>
                )}

              </article>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default EventGallery;
